import { atom } from "recoil";

export const conformidadeLGPD = atom( {
    key: 'conformidadeLGPD', // unique ID (with respect to other atoms/selectors)
    default: { popUpOpen: false, dadosMedicos: false, dadosMarketing: null, dadosSMS: null, confirmado: false }, // default value (aka initial value)
} );
export const mensagemConformidadeLGPD = atom( {
    key: 'mensagemConformidadeLGPD', // unique ID (with respect to other atoms/selectors)
    default: { popUpOpen: false }, // default value (aka initial value)
} );
